"use client";

import * as React from "react";
import { Activity, ChartBar as BarChart3, Globe, Layers, Shield, Zap } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const services = [{
  title: "Roof & Attic",
  description: "Visual inspection of accessible roof coverings, flashing, drainage components, attic areas, and insulation to document visible wear, damage, and moisture concerns.",
  icon: Layers
}, {
  title: "Electrical Systems",
  description: "Full inspection of service panels, wiring, outlets, and safety breakers to identify visible safety concerns.",
  icon: Zap
}, {
  title: "Plumbing & HVAC",
  description: "Testing of accessible plumbing fixtures, drainage, water pressure, and installed heating and cooling equipment for general operation at the time of inspection.",
  icon: Activity
}, {
  title: "Foundation & Structure",
  description: "Inspecting visible foundation and structural components, crawlspaces, and exterior grading to protect your home's integrity.",
  icon: Shield
}, {
  title: "Mold & Air Quality Testing Available",
  description: "Mold assessment and sampling are available as separate services when requested and are not included in a standard home inspection.",
  icon: Globe
}, {
  title: "Thermal Imaging",
  description: "Infrared technology may be used as a supplemental tool to identify temperature differences that could indicate moisture, insulation, or electrical concerns. Thermal imaging cannot see through walls or guarantee detection of concealed conditions.",
  icon: BarChart3
}];
export default function OurServices() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="35474" id="our-services" className="bg-background py-[160px] relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-primary/5 rounded-full blur-3xl -translate-y-1/2 pointer-events-none" />
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-primary/5 rounded-full blur-3xl translate-y-1/2 pointer-events-none" />

      <div className="container mx-auto px-6">
        <div className="mb-20 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-secondary mb-6 tracking-tight font-sans">
            What We Inspect
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg font-sans uppercase tracking-widest font-semibold">
            Comprehensive Property Assessment Services
          </p>
        </div>

        <div ref={ref} className={cn("grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
          {services.map((service, i) => <div key={i} data-index={i} className="h-full">
              <Card className="group relative h-full border border-slate-200 bg-card/70 backdrop-blur-md transition-all duration-400 hover:-translate-y-2 hover:border-primary hover:shadow-xl rounded-lg overflow-hidden">
                <CardHeader className="pb-4">
                  <div className="mb-6 inline-flex items-center justify-center">
                    <service.icon className="h-8 w-8 text-primary stroke-[1.5]" />
                  </div>
                  <CardTitle className="text-2xl font-bold text-secondary font-sans tracking-tight">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-base font-normal leading-[1.6] text-muted-foreground font-sans">
                    {service.description}
                  </CardDescription>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}